
    // Import functions from our modular JavaScript files
    import { loadHTML } from './js/html-loader.js';
    import { setupAuthFormToggling, initializeAuthFormEventListeners } from './js/modules/auth.js';
    import {
      auth,
      usersRef,
      set,
      child,
      createUserWithEmailAndPassword,
      signInWithEmailAndPassword,
      onAuthStateChanged,
      sendPasswordResetEmail,
      get
    } from './js/firebase-loader-v2.js';

    let isInitialAuthCheck = true;
    let isLoggingIn = false;
    let redirectTimer = null;
    let authCallbackFired = false;

    // Fallback: If auth state doesn't fire within 5 seconds, show login form anyway
    const authFallbackTimer = setTimeout(() => {
      if (!authCallbackFired) {
        console.warn('⚠️ Auth callback timeout - showing login form as fallback');
        loadAuthFormsAndSetupListeners();
      }
    }, 5000);

    /**
     * Enhanced authentication logic with better debugging
     */
    console.log('🔒 Setting up auth state listener...');
    try {
      onAuthStateChanged(auth, (user) => {
        authCallbackFired = true;
        clearTimeout(authFallbackTimer);
        console.log('🔔 Auth state changed:', { 
          userEmail: user?.email, 
          isInitialAuthCheck, 
          isLoggingIn,
          pathname: window.location.pathname
        });
      
      if (user && isLoggingIn) {
        // User just logged in - redirect immediately
        console.log('✅ User just logged in - redirecting to dashboard');
        isLoggingIn = false;
        
        // Clear any existing redirect timer
        if (redirectTimer) {
          clearTimeout(redirectTimer);
          redirectTimer = null;
        }
        
        console.log('🚀 Redirecting to dashboard...');
        window.location.href = 'dashboard.html';
        return;
      } 
      
      if (user && isInitialAuthCheck) {
        // User is already logged in on page load - redirect
        console.log('✅ Already logged in user detected - redirecting');
        isInitialAuthCheck = false;
        console.log('🚀 Redirecting existing user to dashboard...');
        window.location.href = 'dashboard.html';
        return;
      } 
      
      if (!user) {
        // No user - show login forms
        console.log('ℹ️ No user - showing login forms');
        isInitialAuthCheck = false;
        isLoggingIn = false;
        
        if (redirectTimer) {
          clearTimeout(redirectTimer);
          redirectTimer = null;
        }
        
        loadAuthFormsAndSetupListeners();
      }
    });
    } catch (error) {
      console.error('❌ Error setting up auth state listener:', error);
    }

    // Make the logging in flag globally available with better logging
    window.setLoggingInFlag = function() {
      console.log('🏁 Setting logging in flag to true');
      isLoggingIn = true;
      isInitialAuthCheck = false;
      
      // Clear any existing timers to prevent conflicts
      if (redirectTimer) {
        clearTimeout(redirectTimer);
        redirectTimer = null;
      }
    };

    /**
     * This function loads the HTML for the login forms and then
     * attaches all the necessary event listeners to them.
     */
    async function loadAuthFormsAndSetupListeners() {
      // 1. Load the HTML from your partials file into the 'authContainer' div.
      const loaded = await loadHTML('partials/auth-forms.html', 'authContainer');
      
      if (loaded) {
        // 2. If the HTML loaded successfully, set up the toggling
        //    (e.g., switching between login and register views).
        setupAuthFormToggling();
        
        // 3. Finally, initialize the event listeners for form submissions.
        initializeAuthFormEventListeners(
          auth,
          usersRef,
          set,
          child,
          createUserWithEmailAndPassword,
          signInWithEmailAndPassword,
          sendPasswordResetEmail,
          get
        );
      }
    }
  